import type { Statistica } from "@flow";
import { NormalInfoWrapper } from "../../../tasks/styles";
import { CopyLink } from "../../copyLink";
import { ModalLink } from "../../modalLink";
import { ModalTypes } from "../../loan/modals";

type ApplicationProps= {
  data: any;
  flowId: string;
  setSelectedModal: (modal: typeof ModalTypes[keyof typeof ModalTypes]) => void;
}

interface Detail {
  label: string,
  value: any,
}


function getIndexOfLastRow(details: Detail[]) {
  let lastValidRow = -1
  for (let i = 0; i < details.length; i++) {
    if (details[i].value != null) {
      lastValidRow = i;
    }
  }
  return [lastValidRow]
}
export const ApplicationtRow = ({ data, flowId, setSelectedModal }: ApplicationProps) => {

  // Spain (ES) uses statistica ownExperience variables based on the mapping
  const ownExperienceVars = data?.integrations?.statistica?.ownExperience?.variables
  const externalApplicationId = data?.agentApiApplication?.externalApplicationId

  // Rejection reasons from Statistica
  const statistica: Statistica = data?.integrations?.statistica || {};
  const policiesByStatistica = Object.values(statistica).map(({ policyResults = {} }) => policyResults);
  const rejectedPolicies = policiesByStatistica.flatMap(policyResults => {
    // Check if policyResults is an array (new structure)
    if (Array.isArray(policyResults)) {
      return policyResults
        .filter((policy) => policy.status === 'Red')
        .map((policy) => policy.description?.trim());
    }
    
    // Handle old structure (object with key-value pairs)
    return Object.entries(policyResults)
      .filter(([, result]) => result === 'Red')
      .map(([description]) => description?.trim());
  });
  const rejectReasons = rejectedPolicies.filter(Boolean).map((rule) => `• ${rule}`);
  const sortedRejectReasons = rejectReasons.sort((a, b) => a.localeCompare(b));
  
  // Format amounts for Spain
  const appliedAmount = ownExperienceVars?.appliedAmount ? 
    `${new Intl.NumberFormat('es-ES').format(ownExperienceVars.appliedAmount)} €` : null;
  const refinanceAmount = ownExperienceVars?.refinanceAmount ? 
    `${new Intl.NumberFormat('es-ES').format(ownExperienceVars.refinanceAmount)} €` : null;

  const applicationDetails = [
    { label: 'Flow ID', value: <CopyLink title='Flow ID' value={flowId} /> },
    { label: 'External ID', value: <CopyLink title='External application ID' value={externalApplicationId} /> },
    { label: 'Agent', value: ownExperienceVars?.Agent },
    { label: 'Campaign ID', value: ownExperienceVars?.campaignID },
    { label: 'Purpose', value: ownExperienceVars?.purpose },
    { label: 'Applied amount', value: appliedAmount },
    { label: 'Refinance amount', value: refinanceAmount },
    { label: 'Repayment period', value: ownExperienceVars?.repaymentPeriod },
    { label: 'Origination date', value: ownExperienceVars?.originationDate },
    { label: 'Previous applications', value: ownExperienceVars?.numberOfApplications },
    { label: 'Previous declined', value: ownExperienceVars?.numberOfDeclinedApplications }
  ];

   if (data?.agentApiApplication?.applicant?.psD2Data?.accounts && data.agentApiApplication.applicant.psD2Data.accounts.length > 0)
    applicationDetails.push({
      label: "Transactions",
      value: (<ModalLink title="View Transactions" handleOnClick={() => setSelectedModal(ModalTypes.MANUAL_PAYOUT_APPROVAL)} />),
    });
  
    if (data?.integrations?.cm1)
      applicationDetails.push({
        label: "KYC",
        value: (<ModalLink title="View KYC" handleOnClick={() => setSelectedModal(ModalTypes.KYC)} />),
      });
  
    if (data?.integrations?.electronicIdVideoId)
      applicationDetails.push({
        label: "Video ID",
        value: (<ModalLink title="View Video ID" handleOnClick={() => setSelectedModal(ModalTypes.VIDEO_ID)} />),
      });
  

  const lastIndexes = getIndexOfLastRow(applicationDetails)
  return (
    <>
      <NormalInfoWrapper $header>Application Details</NormalInfoWrapper>
      {applicationDetails.map((detail, index) => {
        if (detail.value === null || detail.value === undefined) return
        return (
          <NormalInfoWrapper key={`application-${index}-${detail.label}`} $isLast={lastIndexes.includes(index) && rejectedPolicies.length<=0}>
            <div>{detail.label}</div>
            <div>{detail.value}</div>
          </NormalInfoWrapper>
        )
      }
      )}
      {
        rejectedPolicies.length > 0 && (
          <>
            <NormalInfoWrapper $isLast>
              Rejection reasons from Statistica
            </NormalInfoWrapper>
            <NormalInfoWrapper $isLast>
              <div>
                {sortedRejectReasons.map((reason) => (
                  <div style={{
                    fontSize: "13px",
                  }} key={`reject reason${reason}`}>{reason}</div>
                ))}
              </div>
            </NormalInfoWrapper>
          </>
        )
      }
    </>
  )
}